import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=350602d6"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=350602d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports